import { render, staticRenderFns } from "./HangtagMaterialEdit.vue?vue&type=template&id=486b0b9d&"
import script from "./HangtagMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./HangtagMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports